import {regionsService, usersService} from "../_services";
import {regionsConstants} from "../_constants";
import {alertActions} from "./alert.actions";
import {history} from "../_helpers";
import {loaderActions} from "./loader.actions";
import {usersActions} from "./users.actions";


function getList(searchVal) {
    return (dispatch) => {
        dispatch(loaderActions.isLoading());

        regionsService.getAll().then(
            (response) => {
                let regions = response.data ? response.data.Items : [];
                if(searchVal) {
                    dispatch(getAllSuccess(filterResult(regions, searchVal)));
                } else {
                    dispatch(getAllSuccess(regions));
                }
                dispatch(loaderActions.clear());
            },
            (error) => {
                dispatchError(error, dispatch);
            }
        );
    };
}


function filterResult (regions, searchVal) {
    return regions.filter(item => {
        return item.Name?.toLowerCase().includes(searchVal.toLowerCase())
            || item.Description?.toLowerCase().includes(searchVal.toLowerCase())
    });
}

function getSingle(id) {
    return (dispatch) => {
        dispatch(loaderActions.isLoading());

        regionsService.getSingle(id).then(
            (response) => {
                dispatch(getSingleSuccess(response));
                dispatch(loaderActions.clear());
            },
            (error) => {
                dispatchError(error, dispatch);
            }
        );
    };

}


function save(data, isUpdate) {
    return (dispatch) => {
        dispatch(loaderActions.isLoading());

        regionsService.save(data, isUpdate).then(
            (response) => {
                dispatch(saveSuccess(response));
                history.push('/admin/regions');
                const message = `Region ${isUpdate ? 'updated' : 'saved'} successfully`;
                dispatch(alertActions.success(message));
                dispatch(loaderActions.clear());
            },
            (error) => {
                dispatchError(error, dispatch);
            }
        );
    };
}

function deleteRegion(regionId) {
    return (dispatch) => {
        dispatch(loaderActions.isLoading());

        regionsService.deleteRegion(regionId).then(
            (response) => {
                dispatch(alertActions.success('Region Deleted Successfully'));
                dispatch(regionsActions.getList());
                dispatch(loaderActions.clear());
            },
            (error) => {
                dispatchError(error, dispatch);
            }
        );
    };
}

function dispatchError(error, dispatch) {
    dispatch(failure(error.toString()));
    dispatch(alertActions.error(error.toString()));
    dispatch(loaderActions.clear());
}


function getAllSuccess(regions) {
    return {type: regionsConstants.GET_ALL_SUCCESS, regions};
}

function saveSuccess(region) {
    return {type: regionsConstants.SAVE_SUCCESS, region};
}

function getSingleSuccess(region) {
    return {type: regionsConstants.GET_SINGLE_SUCCESS, region};
}

function failure(error) {
    return {type: regionsConstants.FAILURE, error};
}


export const regionsActions = {
    getList,
    getSingle,
    save,
    deleteRegion
};


